import { render } from "./SidebarItem.vue?vue&type=template&id=02c5c01e&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=ts"
export * from "./SidebarItem.vue?vue&type=script&lang=ts"

import "./SidebarItem.vue?vue&type=style&index=0&id=02c5c01e&lang=scss&scoped=true"
import "./SidebarItem.vue?vue&type=style&index=1&id=02c5c01e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02c5c01e"

export default script